module.exports = __webpack_public_path__ + "static/img/banner-bg.0bfbeb41.png";